import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaBlock } from '../CtaButton';
import { Accent, SectionHeading } from './SectionHeading';
import { offerIncludes } from '../../data/content';
import { MOCKUP_ALT, MOCKUP_URL } from '../../data/images';

/** The offer — the only block with the price and the real checkout button. */
export function OfferSection() {
  return <section id="offer" aria-labelledby="offer-heading" className="scroll-mt-4 bg-brand-oatmeal px-5 py-16 lg:px-8 lg:py-24" data-id="element-134" data-mp="2casnml5lce04">
      <div className="mx-auto max-w-5xl" data-id="element-135" data-mp="28ai5yb8frz5f">
        <SectionHeading id="offer-heading" title={<>
              Your Next PMU Class Doesn't Have to <Accent data-id="element-137" data-mp="1yjxct3bj7mtw">Start With a Blank Page.</Accent>
            </>} body="Get your teaching resources organized and spend more time doing what you love — educating future PMU professionals." data-id="element-136" data-mp="28bl0ct4ywjq3" />

        <div className="mx-auto mt-12 max-w-4xl overflow-hidden rounded-[28px] border-2 border-brand-gold/50 bg-white shadow-[0_50px_100px_-50px_rgba(120,90,60,0.5)]" data-id="element-138" data-mp="2r71izbmd2779">
          <div className="bg-brand-forest px-6 py-4 text-center" data-id="element-139" data-mp="3hgleadnr28n3">
            <p className="font-body text-[12px] font-bold uppercase tracking-[0.2em] text-brand-ivory" data-id="element-140" data-mp="3hiz7egyvdas0">
              PMU Instructor Ready™ · by Prof. Kyra
            </p>
          </div>

          <div className="px-6 py-10 sm:px-12" data-id="element-141" data-mp="37p8r3zcwc6ne">
            <img src={MOCKUP_URL} alt={MOCKUP_ALT} width={1536} height={1024} loading="lazy" decoding="async" className="mx-auto block w-full max-w-[480px] object-contain" style={{
            filter: 'drop-shadow(0 24px 28px rgba(120, 90, 60, 0.18))'
          }} data-id="element-142" data-mp="2tqr4k4yq9072" />

            <p className="mt-10 text-center font-body text-[12px] font-bold uppercase tracking-[0.18em] text-brand-gold-dark" data-id="element-143" data-mp="2ou0ohhmxa4ln">
              What’s included
            </p>
            <ul className="mx-auto mt-5 grid max-w-2xl gap-x-8 gap-y-3.5 sm:grid-cols-2" role="list" data-id="element-144" data-mp="n01gp690e5dp">
              {offerIncludes.map(item => <li key={item} className="flex items-center gap-3 text-[15px] leading-snug text-brand-charcoal sm:text-[16px]" data-id="element-145" data-mp="1qy6j0q2of60k">
                  <CheckIcon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2.5} aria-hidden="true" data-id="element-146" data-mp="1mxw1qh9fot6e" />
                  {item}
                </li>)}
            </ul>

            <div className="mt-10 border-t border-brand-charcoal/10 pt-9" data-id="element-147" data-mp="2en7j9q1cvaur">
              <CtaBlock label="Yes! I want my PMU system" showPrice data-id="element-148" data-mp="2amxbq8xx0cds" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}